import type {PromiseBasedRecordEditationDataService} from '../../features/record-editation/types';
import type {RecordEditationManagerFactory} from '../../features/record-editation/services/record-editation-manager.factory';
import type {NewRecordEditationParams} from '../../features/record-editation/services/record-editation.data-service';
import type {RecordEditation} from 'typings/portaro.be.types';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';

export class KpRecordEditationModalService {
    public static serviceName = 'kpRecordEditationModalService';

    /*@ngInject*/
    constructor(private recordEditationDataService: PromiseBasedRecordEditationDataService,
                public readonly recordEditationManagerFactory: RecordEditationManagerFactory,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async createRecordEditation(editationParams: NewRecordEditationParams): Promise<RecordEditation | null> {
        try {
            return await this.recordEditationDataService.createNewEditation(editationParams);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            return null;
        }
    }
}